import { Navigate, useLocation } from 'react-router-dom'

import { Spinner } from '@/shared/ui'
import { useSessionStore } from '@/shared/store/session'

/**
 * Guard de ruta.
 *
 * Es una barrera de usabilidad, no de seguridad: quien manipule el estado del
 * navegador la salta. La autorización real la impone el backend en cada
 * endpoint. Aquí solo evitamos enseñar pantallas que van a fallar.
 */
export function RequireAuth({ roles, children }) {
  const status = useSessionStore((state) => state.status)
  const role = useSessionStore((state) => state.user?.role)
  const location = useLocation()

  // 'unknown' = bootstrapSession() sigue en curso. Redirigir aquí expulsaría
  // a un usuario con sesión válida en cada recarga de página.
  if (status === 'unknown') {
    return (
      <div className="flex min-h-64 items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (status !== 'authenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (roles && !roles.includes(role)) {
    return <Navigate to="/" replace />
  }

  return children
}

export function RequireAnonymous({ children }) {
  const status = useSessionStore((state) => state.status)

  if (status === 'authenticated') {
    return <Navigate to="/empresa" replace />
  }

  return children
}
